import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, Inject, OnInit} from '@angular/core';
import {IcDataService} from "../../services/ic-data.service";
import {IcDataSkillService} from "../../services/ic-data.skill.service";
import {firstValueFrom} from "rxjs";




@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './save-skills-dialog.component.html',
    styleUrls: ['./save-skills-dialog.component.scss']
})

export class SaveSkillsDialogComponent implements OnInit {
    completeProgress = 0;
    totalProcessCount = 0;
    currentProcessIndex = 0;
    statusMessage= '';
    hideStopStart= true;
    proccessingSkillName= '';
    progressMode = 'determinate';
    processState = 'Processing';
    startStopMode = 'None';

    constructor(
        private dialogRef: MatDialogRef<SaveSkillsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: SaveSkillsDialogModel,
        private icData: IcDataService,
        private icDataSkillService: IcDataSkillService,
    ) {

    }

    ngOnInit(): void {
        if (this.data.stopStartByDefault){
            this.startStopMode = 'All';
        }
        console.log('datatoProcess',this.data);
        this.startProcessBatch(0);

    }

    startProcessBatch(startIndex: number): void {
        this.processBatchSkillUpdate(this.data.skillsToProcess, startIndex).then( (processResult) => {
                if (processResult.result === 'Complete')
                {
                    this.processState = 'Results';
                }
                else if(processResult.runningSkillError) {
                    this.hideStopStart = false;
                    this.processState = 'Error-RunningSkill';
                }
                else {
                    this.processState = 'Error-Skip';
                    this.statusMessage = processResult.message;
                }
            }
        );
    }

    async pollForSkillStart(skillId: string, interval = 10000, maxRetries = 90): Promise<void> {
        let retries = 0;
        return new Promise<void>((resolve, reject) => {
            const poll = async () => {
                try {
                    await firstValueFrom(this.icData.startSkill(skillId));
                    const skillStatus = await this.icData.getSkill(skillId);
                    console.log('Polling skill status:', skillStatus);
                    if (skillStatus.isRunning) {
                        console.log(`Skill ${skillId} has restarted.`);
                        resolve(); // Resolve if isRunning is false
                    } else {
                        if (retries < maxRetries) {
                            retries++;
                            setTimeout(poll, interval); // Retry polling after the interval
                        } else {
                            reject(new Error(`Polling timed out for skill ${skillId}`));
                        }
                    }
                } catch (error) {
                    reject(error); // Reject in case of an API error
                }
            };
            poll(); // Start polling
        });
    }


    async processBatchSkillUpdate(batchData: any[], startIndex = 0): Promise<any> {
        console.log("batchData",batchData);
        this.totalProcessCount = batchData.length;
        for (let _i = startIndex; _i < batchData.length; _i++) {
            this.hideStopStart = true;
            this.progressMode = 'determinate';
            const updateSkill = batchData[_i];
            this.completeProgress = Math.round((_i + 1) * 100 / batchData.length);
            this.currentProcessIndex = _i;
            this.proccessingSkillName = updateSkill.skillName;
            let curStopStart = false;
            switch (this.startStopMode) {
                case 'None': {
                    curStopStart = false;
                    break;
                }
                case 'All': {
                    curStopStart = true;
                    break;
                }
                case 'Current': {
                    curStopStart = true;
                    this.startStopMode = 'None';
                    break;
                }
            }
            console.log("curStopStart",curStopStart);
            console.log("updateSkill",updateSkill);
            try {
                if (curStopStart) {
                    this.statusMessage = 'Stopping Skill';
                    await firstValueFrom(this.icData.stopSkill(updateSkill.skillId));
                }
                if ('details' in updateSkill) {
                    this.statusMessage = 'Updating Basic Skill Details';
                    console.log("updateSkill.details",updateSkill.details);
                    await firstValueFrom(this.icData.updateSkill(updateSkill.details));
                }
                // if ('dispositions' in updateSkill) {
                //     this.statusMessage = 'Updating Skill Dispositions';
                //     console.log("updateSkill.dispositions",updateSkill.dispositions);
                //     await firstValueFrom(this.icData.updateSkill(updateSkill));
                // }
                if ('skilllAssignments' in updateSkill) {
                    this.statusMessage = 'Fetching Current Skill Assignments';
                    const originalskillAgent =
                        await firstValueFrom(this.icData.getSkillAgents(updateSkill.skillId));
                    this.statusMessage = 'Updating Current Skill Assignments';
                    await this.icDataSkillService.updateSkillWithUsers(originalskillAgent, updateSkill.skilllAssignments, updateSkill.skillId);
                }
                if ('dialerTimezoneSettings' in updateSkill) {
                    this.statusMessage = 'Updating Timezone Settings';
                    await firstValueFrom(this.icData.updateDialerTimezoneSettings(updateSkill.skillId, updateSkill.dialerTimezoneSettings));
                }
                if ('dialerGeneralSettings' in updateSkill) {
                    this.statusMessage = 'Updating General Settings';
                    await firstValueFrom(this.icData.updateDialerGeneralSettings(updateSkill.skillId, updateSkill.dialerGeneralSettings));
                }
                if ('dialerCPASettings' in updateSkill) {
                    this.statusMessage = 'Updating CPA Settings';
                    await firstValueFrom(this.icData.updateDialerCPASettings(updateSkill.skillId, updateSkill.dialerCPASettings));
                }
                if ('dialerRetrySettings' in updateSkill) {
                    this.statusMessage = 'Updating Retry Settings';
                    await firstValueFrom(this.icData.updateDialerRetrySettings(updateSkill.skillId, updateSkill.dialerRetrySettings));
                }
                if ('dialerScheduleSettings' in updateSkill) {
                    this.statusMessage = 'Updating Schedule Settings';
                    if (updateSkill.dialerScheduleSettings.isScheduled === false) {
                        updateSkill.dialerScheduleSettings.isScheduled = true;
                        await firstValueFrom(this.icData.updateDialerScheduleSettings(updateSkill.skillId, updateSkill.dialerScheduleSettings));
                        updateSkill.dialerScheduleSettings.isScheduled = false
                        await firstValueFrom(this.icData.updateDialerScheduleSettings(updateSkill.skillId, updateSkill.dialerScheduleSettings));
                    }
                }
                if ('dialerDeliverySettings' in updateSkill) {
                    this.statusMessage = 'Updating Delivery Settings';
                    await firstValueFrom(this.icData.updateDialerDeliverySettings(updateSkill.skillId, updateSkill.dialerDeliverySettings));
                }
                if ('dialerXSSettings' in updateSkill) {
                    this.statusMessage = 'Updating XS Settings';
                    await firstValueFrom(this.icData.updateDialerXSSettings(updateSkill.skillId, updateSkill.dialerXSSettings));
                }
                // if ('dialerFilter' in updateSkill) {
                //     await firstValueFrom(this.icData.updateDialerFilterSettings(updateSkill.skillId, updateSkill.dialerFilterSettings));
                // }
                if ('dialerListMgmtSettings' in updateSkill && updateSkill.dialerListMgmtSettings) {
                    this.statusMessage = 'Updating List Management Settings';
                    await firstValueFrom(this.icData.updateDialerListMgmtSettings(updateSkill.skillId, updateSkill.dialerListMgmtSettings));
                }
                if (curStopStart) {
                    this.statusMessage = 'Starting Skill';
                    // Polling to wait until isRunning is false
                    this.statusMessage = 'Waiting for skill to Restart...';
                    await this.pollForSkillStart(updateSkill.skillId);
                }
                curStopStart = false
            } catch (error) {
                {
                    console.log(error);
                    const icStatusDescription = error.headers.get('icstatusdescription');
                    return {
                        result: 'Failed',
                        message: 'Failed to Process Skill ' + error.error.error || error.error.error_description + ' - ' + icStatusDescription || '',
                        runningSkillError: (error.error.error_description === 'InvalidState')
                    };
                }

            }
        }
        return {
            result: 'Complete',
            message: 'Update Complete',
            runningSkillError: false
        };
    }

    cancelProcess(): void {
        this.dialogRef.close(false);
    }

    skipSkill(): void {
        this.startProcessBatch(this.currentProcessIndex + 1);
    }

    stopStartSkill(): void {
        this.startStopMode = 'Current'
        this.startProcessBatch(this.currentProcessIndex);
    }

    stopStartAll(): void {
        this.startStopMode = 'All'
        this.startProcessBatch(this.currentProcessIndex);
    }

    closeFinish() {
        this.dialogRef.close(true);
    }


}

export class SaveSkillsDialogModel {
    constructor(
        public skillsToProcess: any[],
        public stopStartByDefault: boolean,
    )
    {

    }
}


